import './ListView.scss'

import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import pluralize from 'pluralize'

import ListHeader from './ListHeader/ListHeader'
import ListContents from './ListContents/ListContents'
import ListSearch from './ListSearch/ListSearch'
import { selectListSearchResults } from '../../reducers'

const ListView = () => {
  const [searchParams] = useSearchParams()
  const searchResults = useSelector(selectListSearchResults)
  const hasSearchTerm = !!searchParams.get('term')
  const [liveRegionMessage, setLiveRegionMessage] = useState('')

  // Sets the live region message value based on the searchResults object.
  useEffect(() => {
    let message = '0 Results'
    let tempMessages = []

    const listsCount = searchResults?.listResults?.totalElements ?? 0
    const itemsCount = searchResults?.itemResults?.length ?? 0

    if (listsCount) {
      tempMessages.push(pluralize('List Result', listsCount, true))
    }

    if (itemsCount) {
      tempMessages.push(pluralize('Item Result', itemsCount, true))
    }

    if (tempMessages.length) {
      message = tempMessages.join(', ')
    }

    setLiveRegionMessage(message)
  }, [JSON.stringify(searchResults)])

  return (
    <div className="list-view">
      <ListHeader />
      <p
        className="list-view__live-region"
        data-testid="list-view__live-region"
        aria-live="polite"
        aria-busy={searchResults.isStale}
      >
        {hasSearchTerm ? liveRegionMessage : ''}
      </p>
      {hasSearchTerm ? <ListSearch /> : <ListContents />}
    </div>
  )
}

export default ListView
